var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.4585,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    stroke: "#2F2D83",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.918 26.4405L9.684 22.8765V21.0045L18.918 17.4225V19.6185L15.138 20.9145L12.366 21.9045V21.9765L15.138 22.9485L18.918 24.2445V26.4405ZM29.5352 26.4405L20.3012 22.8765V21.0045L29.5352 17.4225V19.6185L25.7552 20.9145L22.9832 21.9045V21.9765L25.7552 22.9485L29.5352 24.2445V26.4405Z",
    fill: "#2F2D83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftleft);
export default __webpack_public_path__ + "static/media/leftleft.f204022bad38c871c8ea849b49b4fd29.svg";
export { ForwardRef as ReactComponent };